var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91813 6.67678L10.7414 9.5L9.68091 10.5604L6.85768 7.73722L6.43091 7.31045V7.914V10.25H4.93091V4.75H10.4309V6.25H8.09491H7.49135L7.91813 6.67678ZM18.5041 7.73722L15.6809 10.5604L14.6205 9.5L17.4437 6.67678L17.8705 6.25H17.2669H14.9309V4.75H20.4309V10.25H18.9309V7.914V7.31045L18.5041 7.73722ZM10.7414 15.5L7.91813 18.3232L7.49135 18.75H8.09491H10.4309V20.25H4.93091V14.75H6.43091V17.086V17.6896L6.85768 17.2628L9.68091 14.4396L10.7414 15.5ZM18.9309 17.086V14.75H20.4309V20.25H14.9309V18.75H17.2669H17.8705L17.4437 18.3232L14.6205 15.5L15.6809 14.4396L18.5041 17.2628L18.9309 17.6896V17.086Z",
    fill: "#4A4949",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.31a9d183307acf0e71125e52ad9a03c1.svg";
export { ForwardRef as ReactComponent };